/**
 * @module sendEvents
 * @alias Fiverr.sendClientEvents
 * @since 2.0.0
 */

import { alias } from '../../__alias';

/**
 * Report BI events to server. Aliases Fiverr.sendClientEvents
 * @param  {...Object[]} event TBC
 * no return value
 *
 * @example
 * Fiverr.sendEvents(
 *   {...},
 *   {...},
 *   {...}
 * )
 */
export const sendEvents = alias('sendClientEvents');
